import './LegalPage.css';
import termsBanner from '../assets/images/legal-terms-banner.jpg';
import LegalContent from '../components/LegalContent';
import termsContent from '../content/termsContent';

function TermsAndConditions() {
  return (
    <>
      <section className="legal-banner legal-banner-terms">
        <div
          className="legal-banner-img"
          style={{ backgroundImage: `url(${termsBanner})` }}
        />
        <p className="legal-banner-title">Terms &amp; Conditions</p>
      </section>
      <section className="section">
        <div className="container legal-page">
          <span className="eyebrow">Legal</span>
          <LegalContent blocks={termsContent} />
        </div>
      </section>
    </>
  );
}

export default TermsAndConditions;
